
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import MemoryDataTable from "@/components/wmc/MemoryDataTable.vue";
import PaginatorComponent from "../Paginator.vue";
import QuestionDialogComponent from "@/components/dialogs/QuestionDialog.vue";
import { Watch } from "vue-property-decorator";
import PedidoService from "@/services/PedidoService";
import NumberInput from "@/components/wmc/NumberInput.vue";
import ProdutosService from "@/services/ProdutosService";

const PedidoStore = namespace("Pedido");
const Notifications = namespace("Notifications");

const initialPaginacao = {
  itemsPerPage: 10,
  page: 1,
};

@Component({
  components: {
    NumberInput,
    PaginatorComponent,
    MemoryDataTable,
    QuestionDialogComponent,
  },
})
export default class TrocasContainer extends Vue {
  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  private headers = [
    {
      text: "Cód.",
      align: "start",
      sortable: true,
      value: "id",
      width: "7%",
    },
    {
      text: "Descrição",
      align: "start",
      sortable: "true",
      value: "descricao_portal",
      width: "35%",
    },
    {
      text: "UN",
      align: "start",
      sortable: "true",
      value: "unidadeMedida",
      width: "5%",
    },
    {
      text: "QTDE",
      align: "center",
      value: "quantidade",
      sortable: "true",
      width: "15%",
    },
    {
      text: "Marca",
      align: "start",
      sortable: "true",
      value: "marca.descricao",
      width: "15%",
    },
    {
      text: "Grupo",
      align: "start",
      sortable: "true",
      value: "grupo.descricao",
      width: "30%",
    },
    {
      text: "Ações",
      align: "start",
      value: "acoes",
      width: "5%",
      sortable: false,
    },
  ];

  private currentTab = 0;
  private isLoading = true;
  private count = 0;
  private textSearchTimer;

  // listas
  private produtoList = [] as Array<any>;
  private produtoListSelected = [] as Array<any>;

  // filters
  private searchText = "";
  private paginacao = initialPaginacao;

  @PedidoStore.Action
  private setTrocasPedido!: (state: any[]) => void;

  @PedidoStore.State
  private trocas!: any[];

  mounted() {
    this.produtoListSelected = this.trocas.map((x) => ({
      id: x.produto.id,
      quantidade: x.quantidade,
    }));
    this.buscarDadosApi();
    this.buscarProdutosTrocasSelecionados();
  }

  @Watch("paginacao")
  onPaginacaoChanged(value: any, oldValue: any) {
    if (
      value !== oldValue ||
      value.page !== oldValue.page ||
      value.itemsPerPage !== oldValue.itemsPerPage
    ) {
      this.buscarDadosApi();
    }
  }

  async buscarProdutosTrocasSelecionados() {
    if (!this.produtoListSelected.length) return;
    await ProdutosService.buscarProdutosPorId(
      this.produtoListSelected.map((x) => x.id)
    ).then((res) => {
      this.produtoListSelected?.forEach((item: any, index: number) => {
        const produto = res?.data?.find((x) => x.id === item.id);
        if (produto) {
          produto.quantidade = item.quantidade;
          this.produtoListSelected[index] = produto;
        }
      });
    });
  }

  buscarDadosApi() {
    this.isLoading = true;

    const filter = {
      search: this.searchText,
    };

    const pagination = this.paginacao;

    PedidoService.getAllProdutosFromPedidos(filter, pagination).then(
      (res) => {
        const response = res?.data;
        this.produtoList = response?.data || [];
        this.produtoList.forEach((x) => {
          x.quantidade = 0;
        });

        this.count = response?.count || 0;

        this.produtoList?.forEach((item: any) => {
          item.quantidade =
            this.produtoListSelected.find((x: any) => x.id === item.id)
              ?.quantidade || 0;
        });

        this.isLoading = false;
      },
      (error) => {
        this.showErrorMessage(
          "Erro ao buscar" + error?.response?.data || error?.message
        );
        this.isLoading = false;
      }
    );
  }

  onSearchTextChanged(value: string, oldValue: string) {
    clearTimeout(this.textSearchTimer);
    this.textSearchTimer = setTimeout(() => {
      this.paginacao.page = 1;
      this.searchText = value;
      this.buscarDadosApi();
    }, 600);
  }

  alterarQtdeProduto(value: number, item: any, fixed: boolean) {
    if (!item.quantidade) {
      item.quantidade = 0;
    }

    if (fixed) {
      item.quantidade = value < 0 ? 0 : value;
    } else {
      item.quantidade = Number(item.quantidade) + value;
    }

    this.$forceUpdate();

    if (item.quantidade <= 0) {
      const index = this.produtoListSelected.findIndex((x) => x.id == item.id);
      this.produtoListSelected.splice(index, 1);
    }

    if (
      item.quantidade > 0 &&
      !this.produtoListSelected.some((x) => x.id == item.id)
    ) {
      this.produtoListSelected.push(item);
    }

    const pedidoProduto = this.produtoListSelected.map((x) => {
      return {
        produto: {
          id: x.id,
        },
        quantidade: x.quantidade,
        unidadeMedida: x.unidadeMedida,
      };
    });

    this.setTrocasPedido(pedidoProduto);
  }

  onlyNumber($event) {
    // Permitir apenas números e controle de teclas
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      // 46 is dot
      $event.preventDefault();
    }
  }

  onRemoveProduto(id: number) {
    const index = this.produtoListSelected.findIndex((x) => x.id === id);
    this.produtoListSelected.splice(index, 1);
    this.$forceUpdate();

    const produto = this.produtoList.find((x) => x.id === id);
    if (produto) {
      produto.quantidade = 0;
    }

    this.setTrocasPedido(
      this.produtoListSelected.map((x) => {
        return {
          produto: {
            id: x.id,
          },
          quantidade: x.quantidade,
          unidadeMedida: x.unidadeMedida,
        };
      })
    );
  }
}
